import React from 'react'
import style from './miniPaintingItem.module.css'
export const MiniPaintingItem = (props) => {

    return <div style={{
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1%',
        marginTop: '5%',
        display: 'flex',
        flex: 1,
        width: '100%',

        minWidth: '23rem'
    }} className={style.miniPaintingItem}>
        <div>
            <div style={{color:'rgb(48,93,150)', fontWeight: 'bold'}}>{props.name}</div>
            <img src={props.picture} width={'100%'} style={{ border: '2px solid rgb(48,93,150)', maxWidth: '19rem',
                maxHeight: '18rem',}}/>
        </div>
    </div>
}

